var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheelBase = function SvgWheelBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    viewBox: "0 0 400 400"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "WheelBase_svg__a",
    x1: 365.56,
    x2: 8.218,
    y1: 83.48,
    y2: 440.822,
    gradientTransform: "scale(.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 205,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 201,
    fill: "url(#WheelBase_svg__a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 179,
    fill: "currentColor"
  })));
};
export default SvgWheelBase;